import useStore from 'base/store'
import {useOpen} from 'common/hooks'
import {Button, Box} from 'common/components'
import {PermissionType, SetNewForecast, ForecastFormItem} from 'common/types'
import {RequestForecastModal} from '.'

interface RequestForecastItemAddProps {
  projectUuid?: string
  requestUuid?: string
  minDate: Date
  loanValue: number
  forecast?: ForecastFormItem[]
  setNewForecast?: SetNewForecast
  isVariation?: boolean
}

export default function RequestForecastItemAdd({
  projectUuid,
  requestUuid,
  minDate,
  forecast,
  loanValue,
  setNewForecast,
  isVariation,
}: RequestForecastItemAddProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const [isOpen, handleOpen, handleClose] = useOpen()

  const isNotAllowed = (!permissions?.includes(
    !!isVariation 
    ? 'edit variation forecast'
    : 'edit forecast'
  ))
  return (
    <>
      <Box align="center" mb={24}>
      { !isNotAllowed &&
        <Button variant="secondary" onClick={handleOpen}>
          add forecast item
        </Button>
      }
      </Box>
      <RequestForecastModal
        open={isOpen}
        projectUuid={projectUuid}
        requestUuid={requestUuid}
        minDate={minDate}
        forecast={forecast}
        loanValue={loanValue}
        setNewForecast={setNewForecast}
        onClose={handleClose}
      />
    </>
  )
}
